// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zm-drag-virtual[data-v-7d7af2f2]{position:fixed;border:2px solid red;background-color:#fff;z-index:8888;overflow:hidden;display:none;opacity:.8;pointer-events:none}.is-process[data-v-7d7af2f2]{display:block}.zm-drag-virtual.is-ready[data-v-7d7af2f2]{border-color:green}", ""]);
// Exports
module.exports = exports;
